module.exports = __webpack_public_path__ + "assets/d5a1ccb78b6ed0037ceb5e61d4a50eb7.mp3";